import { h, render } from 'preact';
import { riperStorage } from '@/base/helpers';
import ProductButton from './ProductButton';

const ProductButtonRenderer = {
  _containers: [],
  setContainers() {
    this._containers = [];
    const placeholders = document.getElementsByClassName('beans-product');

    if (!placeholders.length) return this._containers;

    for (let i = 0; i < placeholders.length; i++) {
      this._containers.push({
        target: placeholders[i],
        buttonClass: placeholders[i].getAttribute('beans-btn-class') || '',
        buttonParams: {
          productID: placeholders[i].getAttribute('beans-product-id'),
          variantID: placeholders[i].getAttribute('beans-variant-id'),
          variantPrice: placeholders[i].getAttribute('beans-variant-price'),
        },
      });
    }

    return this._containers;
  },
  render() {
    const { riperDisplay: display } = riperStorage;
    const redeemableProductsIDs = display.redemption.reward_exclusive_product_cms_ids;
    this._containers.forEach(function (container) {
      const { buttonClass, buttonParams } = container;
      const isRedeemable = redeemableProductsIDs.indexOf(buttonParams.productID) !== -1;
      if (isRedeemable) {
        container.node = (
          <ProductButton
            account={riperStorage.account}
            coupon={riperStorage.coupon}
            display={display}
            buttonClass={buttonClass}
            buttonParams={buttonParams}
            onAbout={riperStorage.onAbout}
          />
        );
        container.target.innerHTML = '';
        render(container.node, container.target);
      }
    });
  },
};

export default ProductButtonRenderer;
